import React from "react";
import InvestDashboardContent from "../../components/InvestDashboardContent";
import Header from "../../layouts/Header";
import GradientBackground from "../../layouts/GradientBackground";

export default function InvestDash() {
  return (
    <GradientBackground>
      <Header />

      <InvestDashboardContent />
    </GradientBackground>
  );
}
